import * as VacationService from "@/services/vacation";
import useRequest from "@/composables/useRequest";
import { ref, computed } from "@nuxtjs/composition-api";

import { isEmpty } from "@/utils/helpers";

export default function useVacationSotckDest() {
  const { state: citys, execute: fetchDist } = useRequest(
    (product_no, date) =>
      VacationService.getProductDst({
        product_no,
        date
        // date: selectedStock.value.date
      }),
    [],
    {
      immediate: false
    }
  );

  const selectedCityId = ref("");
  const selectedMealId = ref("");

  const meals = computed(() => {
    if (isEmpty(citys.value) || !selectedCityId.value) {
      return [];
    }

    let city = citys.value.find(city => city.city_id === selectedCityId.value);
    return city.set_meal;
  });

  return {
    meals,
    citys,
    selectedCityId,
    selectedMealId,
    fetchDist
  };
}
